"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var react_native_1 = require("react-native");
var ThemeProvider_1 = require("../theme/ThemeProvider");
var ATLAtomTextInput_1 = require("../atoms/ATLAtomTextInput");
var KeyboardTypeEnum_1 = require("../enums/KeyboardTypeEnum");
var ReturnKeyTypeEnum_1 = require("../enums/ReturnKeyTypeEnum");
var defaultProps = {
    complementary: false,
    disabled: false,
    hideClearButton: false,
    isInputFocused: false,
    required: false,
    showCounter: false,
    showVisibilityToggle: false,
    keyboardType: KeyboardTypeEnum_1.KeyboardTypeEnum.default,
    maxLength: undefined,
    multiline: false,
    returnKeyType: ReturnKeyTypeEnum_1.ReturnKeyTypeEnum.done,
    textInputBaseProps: {}
};
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.InputWrapper = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding:  ", "px\n\t          ", "px;\n"], ["\n\tpadding:  ", "px\n\t          ", "px;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalMargin || atlTheme.SpacingAtomic;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalMargin || atlTheme.SpacingInputMarginHorizontal;
});
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLTextInput = react_1.default.forwardRef(function (_a, ref) {
    var value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, errorText = _a.errorText, helpText = _a.helpText, leftAdornment = _a.leftAdornment, leftIcon = _a.leftIcon, rightAdornment = _a.rightAdornment, rightButtonIcon = _a.rightButtonIcon, title = _a.title, onPressRightIcon = _a.onPressRightIcon, onSubmitEditing = _a.onSubmitEditing, complementary = _a.complementary, disabled = _a.disabled, hideClearButton = _a.hideClearButton, isInputFocused = _a.isInputFocused, required = _a.required, showCounter = _a.showCounter, showVisibilityToggle = _a.showVisibilityToggle, blurOnSubmit = _a.blurOnSubmit, autoCapitalize = _a.autoCapitalize, keyboardType = _a.keyboardType, maxLength = _a.maxLength, multiline = _a.multiline, returnKeyType = _a.returnKeyType, horizontalMargin = _a.horizontalMargin, verticalMargin = _a.verticalMargin, textInputBaseProps = _a.textInputBaseProps;
    var theme = ThemeProvider_1.useTheme();
    // Returns complete ATLTextInput
    return (react_1.default.createElement(exports.InputWrapper, { horizontalMargin: horizontalMargin, verticalMargin: verticalMargin },
        react_1.default.createElement(ATLAtomTextInput_1.ATLAtomTextInput, __assign({ ref: ref, value: value, onChange: onChange, onBlur: onBlur, onPressRightButton: onPressRightIcon, onSubmitEditing: onSubmitEditing, title: title, leftAdornment: leftAdornment, rightAdornment: rightAdornment, errorText: errorText, helpText: helpText, rightButtonIcon: rightButtonIcon, leftIcon: leftIcon, disabled: disabled, isInputFocused: isInputFocused, required: required, showCounter: showCounter, hideClearButton: hideClearButton, showVisibilityToggle: showVisibilityToggle, blurOnSubmit: blurOnSubmit, disabledOpacity: theme.OpacityDisabled, boxColor: complementary ? theme.ColorComplementary1 : theme.ColorHighContrast, errorColor: theme.ColorDanger, focusColor: theme.ColorInfo, labelColor: complementary ? theme.ColorComplementary1 : theme.ColorLowContrast, leftIconColor: theme.ColorBrand2Default, maxLength: maxLength, multiline: multiline, keyboardType: keyboardType, returnKeyType: returnKeyType, autoCapitalize: autoCapitalize }, textInputBaseProps))));
});
exports.ATLTextInput.defaultProps = defaultProps;
exports.ATLTextInput.displayName = 'ATLTextInput';
var templateObject_1;
